<script setup lang="ts"></script>

<template>
    <div class="announcement-box">
        <slot> </slot>

        <img
            src="~/assets/icons/warning.svg"
            alt="warning"
            aria-hidden="true"
        />
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/announcement-message.scss';
</style>
